import React, { useEffect, useState } from "react";
import { Button, Col, Form, FormGroup, Modal, Table } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOptoutList,
  updateOptout,
  deleteOptout,
} from "../../../redux/actions/campaignAction";
import Loading from "../../Loading";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Optout = (props) => {
  const dispatch = useDispatch();
  const authToken = props.authToken;

  const optoutList = useSelector((state) => state.campaign?.optout_list);
  const isLoading = useSelector((state) => state.campaign.loading);

  const search = props.searchField || "";

  const [editModal, setEditModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [editEmail, setEditEmail] = useState("");

  const [deleteItem, setDeleteItem] = useState(null);

  useEffect(() => {
    dispatch(fetchOptoutList(authToken, search));
  }, [search]);

  const openEdit = (item) => {
    setEditItem(item);
    setEditEmail(item.email_id);
    setEditModal(true);
  };

  const closeEdit = () => {
    setEditModal(false);
    setEditItem(null);
    setEditEmail("");
  };

  const handleUpdate = () => {
    if (!EMAIL_REGEX.test(editEmail.trim())) return;
    dispatch(updateOptout(authToken, editItem.id, editEmail.trim(), closeEdit));
  };

  const handleDelete = () => {
    dispatch(deleteOptout(authToken, deleteItem.id, () => setDeleteItem(null)));
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr.replace(" ", "T"));
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleString();
  };

  return (
    <div className="list-campaign optout-list">
      {isLoading && <Loading />}

      <div className={"hashtag-list-title-card  list-custom mb-0"}>
        <Table>
          <tbody>
            <tr>
              <td className="hashtag-name-head">
                <span>Name</span>
              </td>
              <td style={{ width: "25%" }}>
                <span className="bordering-custom date-style">Email</span>
              </td>
              <td style={{ width: "15%" }}>
                <span className="bordering-custom date-style">Phone</span>
              </td>
              <td style={{ width: "20%" }}>
                <span className="bordering-custom date-style">Last Edited</span>
              </td>
              <td style={{ justifyContent: "end" }} className="d-flex">
                <div className="card-footer-action list-card">Quick Actions</div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>

      {optoutList?.length > 0 &&
        optoutList.map((item, index) => (
          <Col key={item.id || index}>
            <div className="hashtag-list-card campaign my-3">
              <Table>
                <tbody>
                  <tr>
                    <td title={item.name} className="hashtag-name">
                      {item.name ? item.name.slice(0, 25) : "-"}
                      {item.name?.length > 25 && <span>...</span>}
                    </td>
                    <td style={{ width: "25%" }} title={item.email_id}>
                      <span style={{ border: "none" }} className="bordering-date date-style">
                        {item.email_id?.slice(0, 35)}
                        {item.email_id?.length > 35 && <span>...</span>}
                      </span>
                    </td>
                    <td style={{ width: "15%" }}>
                      <span style={{ border: "none" }} className="bordering-date date-style">
                        {item.phone || "-"}
                      </span>
                    </td>
                    <td style={{ width: "20%" }}>
                      <span style={{ border: "none" }} className="bordering-date date-style">
                        {formatDate(item.updated_at || item.created_at)}
                      </span>
                    </td>
                    <td style={{ justifyContent: "end", gap: "15px" }} className="d-flex">
                      {/* <div
                        className="card-footer-action list-card"
                        onClick={() => openEdit(item)}
                      >
                        <span className="edit-icon">
                          <Icon.Pencil color="#64B6E7" />
                        </span>
                      </div> */}
                      <div
                        className="card-footer-action list-card"
                        onClick={() => setDeleteItem(item)}
                      >
                        <span className="edit-icon">
                          <Icon.Trash color="#64B6E7" />
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Col>
        ))}

      {(!optoutList || optoutList.length === 0) && (
        <div className="no-data asset">
          <span>
            <Icon.Inbox />
          </span>
          <br />
          No Data
        </div>
      )}

      {/* Edit modal */}
      <Modal show={editModal} onHide={closeEdit}>
        <Modal.Header closeButton>
          <div className="fw-bold h5">Edit Opt-out User</div>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="text"
              autoComplete="off"
              placeholder="Email"
              value={editEmail}
              onChange={(e) => setEditEmail(e.target.value)}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeEdit}>
            Cancel
          </Button>
          <Button variant="info" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete confirm */}
      <Modal
        className="delete-popup"
        show={!!deleteItem}
        onHide={() => setDeleteItem(null)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to remove {deleteItem?.email_id} from the opt-out
          list?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleDelete}>
            Delete
          </Button>
          <Button variant="secondary" onClick={() => setDeleteItem(null)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Optout;
